<template>
    <div v-if="selectedTrip">

        <div v-if="!openLocalisationActive">
            <b-breadcrumb>
                <b-breadcrumb-item>{{ selectedTrip.short_desc}}</b-breadcrumb-item>
                <b-breadcrumb-item active>Edit image positions</b-breadcrumb-item>
            </b-breadcrumb>

            <h3>Add positions you know to your images</h3>

            <p class="title">Select an image bellow, and on the next screen you will be able to add the position. You dont need to add position to all of your photos, but we recommend you add <b>{{recommendedNbPositions}} positions</b></p>

            <vue-select-image :dataImages="albumImages"
                              :is-multiple="false"
                              @onselectimage="onSelectImage">
            </vue-select-image>

        </div>

        <div v-if="openLocalisationActive">

            <h3>Add positions you know to your images</h3>

            <p class="title">Move the red marker to the position where the photo was taken.</p>

            <b-breadcrumb>
                <b-breadcrumb-item>{{ selectedTrip.short_desc}}</b-breadcrumb-item>
                <b-breadcrumb-item>Edit image positions</b-breadcrumb-item>
                <b-breadcrumb-item active>{{selectImage.alt}}</b-breadcrumb-item>
            </b-breadcrumb>

            <photos-localisation
                    ref="photoLoc"
                    :albumImages="albumImages"
                    :image="selectImage"
                    :trip="selectedTrip"
                    :read-only="false"
                    v-on:close="closeSetPosition">

            </photos-localisation>
        </div>


        <div class="alert alert-danger" v-if="error">
            <button type="button" aria-hidden="true" class="close">×</button>
            <span>{{error}}</span>
        </div>


    </div>
</template>

<script>
  import firebase from 'firebase'

  const fb = require('../firebaseConfig.js')
  import { mapState } from 'vuex'
  import fetch from 'node-fetch'
  /////////////
  import Vue from 'vue'

  import IcFirebaseUploader from 'ic-firebase-uploader'
  import 'ic-firebase-uploader/dist/ic-firebase-uploader.min.css'
  import { mediasCollection } from '@/firebaseConfig'

  Vue.component('ic-firebase-uploader', IcFirebaseUploader)
  /////////////////
  import gmapsInit from '@/googleMapsConfig'

  /////////////////
  import UIHelpersMixins from '@/mixims/UIHelpersMixins'

  const CommonLib = require('@/lib/Common')

  import PhotosLocalisation from '@/components/PhotosLocalisation/PhotosLocalisation'
  /////////////////

  export default {
    components: {
      PhotosLocalisation
    },
    mixins:
                [
                  UIHelpersMixins,
                ],
    props:      [
      'selectedTrip'
    ],
    data ()
    {
      return {
        alert: '',

        initialSelected: [],
        albumImages:     [],

        // Set pos tab
        openLocalisationActive: false,
        albumImagesWithoutGPS:  [],
        selectImage:            null,
      }
    },
    mounted:    function () {

      // At this point, the child GmapMap has been mounted, but
      // its map has not been initialized.
      // Therefore we need to write mapRef.$mapPromise.then(() => ...)
      var that = this

      gmapsInit().then(function (google) {

      })
    },
    methods:    {

      handleAlbumReload ()
      {
        if (!this.selectedTrip)
        {
          return
        }
        var that = this

        fb.mediasCollection.where('tripId', '==', this.selectedTrip.id).orderBy('capturedOn', 'asc')
          .onSnapshot(function (querySnapshot) {

            that.albumImages           = []
            that.albumImagesWithoutGPS = []

            querySnapshot.forEach(function (doc) {

              var data = doc.data()
              if (data.thumbsPath)
              {
                var img = {
                  id:         doc.id,
                  src:        CommonLib.getImageURL(data.thumbsPath[256]),
                  alt:        data.metadata.name,
                  latitude:        data.metadata.latitude || null,
                  longitude:        data.metadata.longitude || null,
                  capturedOn: data.capturedOn,
                }

                that.albumImages.push(img)

                if (data.metadata.latitude &&
                  data.metadata.longitude)
                {

                } else
                {
                  that.albumImagesWithoutGPS.push(img)
                }
              }

            })

            if (!that.albumImagesWithoutGPS.length && that.albumImages.length)
            {
              that.albumImagesWithoutGPS = that.albumImages
            }

          })
      },

      findMediaIndexByDate: function (haystack, needle) {
        for (var i = 0; i < haystack.length; i += 1)
        {
          if (haystack[i].capturedOn === needle.capturedOn)
          {
            return i
          }
        }
        return -1
      },
      closeSetPosition ()
      {
        this.openLocalisationActive = false
      },

      onSelectImage (selectedImage)
      {
        var that = this

        this.openLocalisationActive = true
        this.selectImage            = selectedImage
      }
      ,
    }, // methods
    computed:   {
      recommendedNbPositions()
      {

        return Math.max(0, Math.round(this.albumImages.length /15)  - (this.albumImages.length - this.albumImagesWithoutGPS.length))

      },
      imagesWithoutGPS ()
      {
        return this.albumImagesWithoutGPS
      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },
      error ()
      {
        return this.$store.state.error
      },
    },
    watch:      {

      selectedTrip: function () {
        console.log('WATCH: selectedTrip')
        this.handleAlbumReload()
      },
    }
  }
</script>


<style lang="scss" scoped>
    .md-dialog {
        max-width: 768px;
        width: 768px;
    }
</style>jjj